import ATMLoadProfileEditComponent from './atm_load_profile.edit.component';

let ATMLoadProfileEditModule = angular.module('atmLoadProfileEdit', [
])

.component('atmLoadProfileEdit', ATMLoadProfileEditComponent)

.name;

export default ATMLoadProfileEditModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/atm_load_profile/edit/index.js